// =============================================================================
// src/app/landing-view.ts — Decide a view de abertura do app (pura).
//
// Proveniencia: reforma institucional 2026-06 (D2). Antes a logica vivia
//   inline em explore-route.init() ("abre Explorar exceto ?view=grafo|workspace").
//   Agora o DEFAULT e o Briefing do dia; ?view= preserva os deep-links antigos
//   e ganha o valor novo 'explore'. Workspace continua se auto-abrindo
//   via syncFromURL proprio — aqui so garantimos que briefing/explore NAO
//   abram por cima dele.
//
// 2026-07-20: o deep-link `?view=grafo` foi DESATIVADO junto com o Grafo de
//   Influencias (pedido do usuario) — passa a cair no default 'briefing', senao
//   a URL seria uma porta dos fundos para uma superficie fechada na UI.
// 2026-07-25: idem para `?view=workspace` — a aba Workspace foi desativada no
//   pacote de ajustes do Analytics (pill disabled + guard em DISABLED_PILL_VIEWS
//   + syncFromURL da workspace-route neutralizado). Para religar, reverter os 3
//   pontos + este predicado.
// =============================================================================

/** Views de abertura possiveis (briefing e o default da reforma D2). */
export type LandingViewName = 'briefing' | 'explore' | 'workspace';

/**
 * Resolve a view de abertura a partir da query string.
 *
 * @example
 *   resolveLandingView('');                  // 'briefing' (default)
 *   resolveLandingView('?view=explore');     // 'explore'
 *   resolveLandingView('?view=grafo');       // 'briefing' (grafo desativado)
 *   resolveLandingView('?view=workspace');   // 'briefing' (workspace desativado)
 */
export function resolveLandingView(search: string): LandingViewName {
  const view = new URLSearchParams(search).get('view');
  if (view === 'explore') return view;
  return 'briefing';
}
